 <nav class="side-nav">
     <ul>
         <li>
             <span>
               <svg id="upload-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 36 36">
                  <defs>
                    <clipPath id="clip-path-upload">
                      <path id="Mask" d="M1,30a1,1,0,1,1,0-2H27a1,1,0,1,1,0,2Zm12-5.52V3.83L4.81,12A1,1,0,1,1,3.39,10.61L14,0,24.6,10.59A1,1,0,0,1,23.19,12L15,3.83V24.48a1,1,0,0,1-2,0Z"/>
                    </clipPath>
                  </defs>
                  <g id="color" transform="translate(4 3)">
                    <path id="Mask-2" data-name="Mask" d="M1,30a1,1,0,1,1,0-2H27a1,1,0,1,1,0,2Zm12-5.52V3.83L4.81,12A1,1,0,1,1,3.39,10.61L14,0,24.6,10.59A1,1,0,0,1,23.19,12L15,3.83V24.48a1,1,0,0,1-2,0Z"/>
                    <g id="color-2" data-name="color" clip-path="url(#clip-path-upload)">
                      <g id="color-3" data-name="color" transform="translate(-4 -3)">
                        <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                      </g>
                    </g>
                  </g>
                </svg>
                

             </span>
            <span>Carregar arquivos</span> 
         </li>

         <li>
           <span>  

            <svg id="bundle-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 36 36">
              <defs>
                <clipPath id="clip-path-bundle-2">
                  <path id="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
                </clipPath>
              </defs>
              <g id="color" transform="translate(2 2)">
                <path id="Mask-2" data-name="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
                <g id="color-2" data-name="color" clip-path="url(#clip-path-bundle-2)">
                  <g id="color-3" data-name="color" transform="translate(-2 -2)">
                    <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                  </g>
                </g>
              </g>
            </svg>
           </span>
           <span>Bookmarks</span> 
        </li>


        <li>
          <span>
                
            <svg id="blocks-group-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 36 36">
              <defs>
                <clipPath id="clip-path-block-line">
                  <path id="Mask" d="M23.08,31.822,16,28.562l-7.08,3.26a1,1,0,0,1-.84,0l-7.5-3.45a1,1,0,0,1-.58-.91v-9.78a1,1,0,0,1,.58-.91l6.9-3.18V4.452a1,1,0,0,1,.58-.91l7.5-3.45a1,1,0,0,1,.84,0l7.5,3.45a1,1,0,0,1,.6.9v9.14l6.93,3.19a1,1,0,0,1,.571.91v9.78a1,1,0,0,1-.58.91l-7.5,3.45a1,1,0,0,1-.841,0Z" transform="translate(0.1 0.988)"/>
                </clipPath>
              </defs>
              <g id="color" transform="translate(2 1)">
                <path id="Mask-2" data-name="Mask" d="M23.08,31.822,16,28.562l-7.08,3.26a1,1,0,0,1-.84,0l-7.5-3.45a1,1,0,0,1-.58-.91v-9.78a1,1,0,0,1,.58-.91l6.9-3.18V4.452a1,1,0,0,1,.58-.91l7.5-3.45a1,1,0,0,1,.84,0l7.5,3.45a1,1,0,0,1,.6.9v9.14l6.93,3.19a1,1,0,0,1,.571.91v9.78a1,1,0,0,1-.58.91l-7.5,3.45a1,1,0,0,1-.841,0Z" transform="translate(0.1 0.988)"/>
                <g id="color-2" data-name="color" clip-path="url(#clip-path-block-line)">
                  <g id="color-3" data-name="color" transform="translate(-2 -1)">
                    <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                  </g>
                </g>
              </g>
            </svg>

          </span>
           <span>Arquivos Partilhados</span> &nbsp;<span class="badget">35</span>
        </li>

        <li>
          <span>

            <svg id="replay-all-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 36 36">
              <defs>
                <clipPath id="clip-path-replay-1">
                  <path id="Mask" d="M.044,24.7a1,1,0,0,1,1.71-.95A11.78,11.78,0,1,0,12.1,6.341H5.5l2.82,2.51a1,1,0,1,1-1.34,1.49l-5.62-5L6.984.221A1,1,0,0,1,8.324,1.7L5.4,4.341h6.7A13.781,13.781,0,1,1,.044,24.7Zm10.9.75a1.41,1.41,0,0,1-.88-1.32V13.02a1.43,1.43,0,0,1,2.44-1l5.59,5.56a1.456,1.456,0,0,1,.42,1,1.43,1.43,0,0,1-.42,1l-5.59,5.56a1.4,1.4,0,0,1-1,.419A1.531,1.531,0,0,1,10.944,25.45Z" transform="translate(0.956 0.66)" fill="#fff"/>
                </clipPath>
              </defs>
              <g id="color" transform="translate(5 2)">
                <path id="Mask-2" data-name="Mask" d="M.044,24.7a1,1,0,0,1,1.71-.95A11.78,11.78,0,1,0,12.1,6.341H5.5l2.82,2.51a1,1,0,1,1-1.34,1.49l-5.62-5L6.984.221A1,1,0,0,1,8.324,1.7L5.4,4.341h6.7A13.781,13.781,0,1,1,.044,24.7Zm10.9.75a1.41,1.41,0,0,1-.88-1.32V13.02a1.43,1.43,0,0,1,2.44-1l5.59,5.56a1.456,1.456,0,0,1,.42,1,1.43,1.43,0,0,1-.42,1l-5.59,5.56a1.4,1.4,0,0,1-1,.419A1.531,1.531,0,0,1,10.944,25.45Z" transform="translate(0.956 0.66)" fill="#fff"/>
                <g id="color-2" data-name="color" clip-path="url(#clip-path-replay-1)">
                  <g id="color-3" data-name="color" transform="translate(-5 -2)">
                    <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                  </g>
                </g>
              </g>
            </svg>

          </span>

           <span>Aulas</span> &nbsp;<span class="badget" id="badget-aulas">3</span>
        </li>


        <li>
              <span>

                <svg id="users-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 36 36">
                  <defs>
                    <clipPath id="clip-path-user-1">
                      <path id="Mask" d="M8.7,27.756a1.686,1.686,0,0,1-1.7-1.7v-7.6l.2-.3a10.3,10.3,0,0,1,7.9-3.4,10.09,10.09,0,0,1,7.8,3.4l.2.3h.1v7.6a1.753,1.753,0,0,1-1.7,1.7Zm19.3-7v-7.2a8.32,8.32,0,0,0-5.3-1.6,9.632,9.632,0,0,0-1.7.1,6.657,6.657,0,0,0,.9-2.1h.8a9.9,9.9,0,0,1,7,2.5l.3.3v8Zm-28,0v-8l.3-.3a10.289,10.289,0,0,1,7-2.4h.8a6.677,6.677,0,0,0,.9,2.1,8.815,8.815,0,0,0-1.7-.2,8.5,8.5,0,0,0-5.3,1.6v7.2Zm10-12.6a4.85,4.85,0,1,1,4.9,4.9A4.909,4.909,0,0,1,10,8.156Zm12.1.7v-.6a7.024,7.024,0,0,0-.1-1.4,1.706,1.706,0,0,0,.7.1,2.5,2.5,0,0,0,2.2-1.5,2.442,2.442,0,0,0-4.5-1.9,4.263,4.263,0,0,0-1.4-1.3,4.288,4.288,0,0,1,3.8-2.2,4.45,4.45,0,1,1-.1,8.9C22.5,8.956,22.3,8.856,22.1,8.856ZM3.5,6.756a4.442,4.442,0,1,1,7.6-4.6,9.958,9.958,0,0,0-1.5,1.4,2.528,2.528,0,0,0-2.3-1.5,2.434,2.434,0,0,0-2.4,2.4,2.434,2.434,0,0,0,2.4,2.4,1.7,1.7,0,0,0,.7-.1,6.152,6.152,0,0,0-.1,1.4v.6a1.271,1.271,0,0,1-.6.1A4.406,4.406,0,0,1,3.5,6.756Z" transform="translate(0 0.244)"/>
                    </clipPath>
                  </defs>
                  <g id="color" transform="translate(3 5)">
                    <path id="Mask-2" data-name="Mask" d="M8.7,27.756a1.686,1.686,0,0,1-1.7-1.7v-7.6l.2-.3a10.3,10.3,0,0,1,7.9-3.4,10.09,10.09,0,0,1,7.8,3.4l.2.3h.1v7.6a1.753,1.753,0,0,1-1.7,1.7Zm19.3-7v-7.2a8.32,8.32,0,0,0-5.3-1.6,9.632,9.632,0,0,0-1.7.1,6.657,6.657,0,0,0,.9-2.1h.8a9.9,9.9,0,0,1,7,2.5l.3.3v8Zm-28,0v-8l.3-.3a10.289,10.289,0,0,1,7-2.4h.8a6.677,6.677,0,0,0,.9,2.1,8.815,8.815,0,0,0-1.7-.2,8.5,8.5,0,0,0-5.3,1.6v7.2Zm10-12.6a4.85,4.85,0,1,1,4.9,4.9A4.909,4.909,0,0,1,10,8.156Zm12.1.7v-.6a7.024,7.024,0,0,0-.1-1.4,1.706,1.706,0,0,0,.7.1,2.5,2.5,0,0,0,2.2-1.5,2.442,2.442,0,0,0-4.5-1.9,4.263,4.263,0,0,0-1.4-1.3,4.288,4.288,0,0,1,3.8-2.2,4.45,4.45,0,1,1-.1,8.9C22.5,8.956,22.3,8.856,22.1,8.856ZM3.5,6.756a4.442,4.442,0,1,1,7.6-4.6,9.958,9.958,0,0,0-1.5,1.4,2.528,2.528,0,0,0-2.3-1.5,2.434,2.434,0,0,0-2.4,2.4,2.434,2.434,0,0,0,2.4,2.4,1.7,1.7,0,0,0,.7-.1,6.152,6.152,0,0,0-.1,1.4v.6a1.271,1.271,0,0,1-.6.1A4.406,4.406,0,0,1,3.5,6.756Z" transform="translate(0 0.244)"/>
                    <g id="color-2" data-name="color" clip-path="url(#clip-path-user-1)">
                      <g id="color-3" data-name="color" transform="translate(-3 -5)">
                        <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                      </g>
                    </g>
                  </g>
                </svg>

              </span>
           <span>Professores</span> &nbsp;<span class="badget" id="badget-professor">7</span>
        </li>


        <div class="customizing">
            <li><h5>Customization</h5></li>
            <li><a>1- go to profile and then go back</a></li>
            <li><a>2- after that it'll works well</a></li>
        </div>
        
     </ul>
 </nav>